<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">Incidencias colaboradores</span>
            <v-spacer></v-spacer>
            <v-btn v-if="puedeEditarTipos" small dark color="blue-grey" class="mr-2" tile @click="abrirCatalogoTipos">
              <v-icon left small>mdi-format-list-bulleted</v-icon>
              Tipos
            </v-btn>
            <v-btn class="mr-2" small dark color="green" tile :disabled="!lista.length" @click="exportar">
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn color="orange" dark small tile class="mr-2" @click="abrirAlta">
              <v-icon left small>mdi-plus</v-icon>
              Registrar
            </v-btn>
            <v-btn color="primary" small tile @click="cargarLista">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-sheet class="mt-3 pa-3 rounded-lg incidencia-filtros" color="grey lighten-4" elevation="0">
              <div class="text-overline grey--text text--darken-1 mb-2">Filtros</div>
              <div class="text-caption grey--text text--darken-2 mb-1 d-flex flex-wrap align-center" style="gap: 16px;">
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-magnify</v-icon>
                  Buscar en tabla
                </span>
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-shape-outline</v-icon>
                  Tipo
                </span>
                <span class="d-flex align-center">
                  <v-icon x-small class="mr-1" color="blue-grey">mdi-calendar-range</v-icon>
                  Fecha
                </span>
              </div>
              <v-row dense class="mb-3 align-end">
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    v-model="search"
                    placeholder="Buscar…"
                    outlined
                    hide-details
                    dense
                    single-line
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    color="blue-grey"
                    class="incidencia-buscar"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-select
                    v-model="filtroTipo"
                    :items="tipos"
                    item-text="texto"
                    item-value="id"
                    label="Tipo"
                    dense
                    outlined
                    hide-details
                    clearable
                    color="blue-grey"
                  ></v-select>
                </v-col>
                <v-col cols="6" sm="6" md="2" lg="2">
                  <v-text-field
                    v-model="fechaFiltroDesde"
                    type="date"
                    label="Desde"
                    dense
                    outlined
                    hide-details
                    color="blue-grey"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="2" lg="2">
                  <v-text-field
                    v-model="fechaFiltroHasta"
                    type="date"
                    label="Hasta"
                    dense
                    outlined
                    hide-details
                    color="blue-grey"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="2" lg="4" class="d-flex align-end pb-1">
                  <v-btn small text color="blue-grey darken-1" class="mb-0" @click="limpiarFiltros">
                    <v-icon left small>mdi-backspace-outline</v-icon>
                    Limpiar filtros
                  </v-btn>
                </v-col>
              </v-row>
              <div class="text-caption grey--text text--darken-2 mb-1 d-flex align-center">
                <v-icon x-small class="mr-1" color="blue-grey">mdi-flag-outline</v-icon>
                Estatus
              </div>
              <div class="d-flex flex-wrap align-center mb-3" style="gap: 6px;">
                <v-chip
                  v-for="opt in chipsEstatus"
                  :key="'est-' + String(opt.id)"
                  small
                  label
                  :outlined="filtroEstatus !== opt.id"
                  :color="filtroEstatus === opt.id ? opt.color : 'grey lighten-2'"
                  :text-color="filtroEstatus === opt.id ? 'white' : 'blue-grey darken-2'"
                  class="font-weight-medium"
                  @click="filtroEstatus = opt.id"
                >
                  <v-icon left x-small>{{ opt.icon }}</v-icon>
                  {{ opt.texto }} ({{ conteoEstatus(opt.id) }})
                </v-chip>
              </div>
            </v-sheet>

            <v-sheet
              class="mt-3 px-4 py-3 rounded-lg incidencia-metricas d-flex flex-wrap align-center"
              elevation="1"
            >
              <div class="incidencia-metrica-item d-flex align-center mr-4">
                <div class="incidencia-metrica-icon mr-3">
                  <v-icon color="deep-purple darken-2">mdi-timer-sand</v-icon>
                </div>
                <div v-if="incidenciaMasAntigua">
                  <div class="text-overline deep-purple--text text--darken-2 font-weight-bold mb-0">
                    Incidencia más antigua sin cerrar
                  </div>
                  <div class="incidencia-metrica-valor deep-purple--text text--darken-4 font-weight-bold">
                    #{{ incidenciaMasAntigua.id }} · {{ formatearFecha(incidenciaMasAntigua.fecha) }}
                    <span
                      v-if="incidenciaMasAntigua.colaborador"
                      class="grey--text text--darken-2 font-weight-regular"
                    >
                      · {{ incidenciaMasAntigua.colaborador }}
                    </span>
                  </div>
                </div>
                <div v-else class="text-body-2 grey--text text--darken-2">
                  No hay incidencias abiertas.
                </div>
              </div>
              <div class="d-flex flex-wrap align-center ml-auto" style="gap: 8px;">
                <v-chip
                  small
                  color="orange lighten-5"
                  text-color="orange darken-4"
                  class="incidencia-metrica-chip font-weight-bold"
                >
                  <v-icon left small>mdi-alert-circle-outline</v-icon>
                  Abiertas: {{ conteoEstatus('abierta') }}
                </v-chip>
                <v-chip
                  small
                  color="blue lighten-5"
                  text-color="blue darken-4"
                  class="incidencia-metrica-chip font-weight-bold"
                >
                  <v-icon left small>mdi-message-reply-text</v-icon>
                  En seguimiento: {{ conteoEstatus('en_seguimiento') }}
                </v-chip>
              </div>
            </v-sheet>

            <v-data-table
              :headers="headersTabla"
              :items="listaFiltrada"
              :search="search"
              :item-class="claseFila"
              class="elevation-0 mt-3"
              dense
              :loading="cargar"
              loading-text="Cargando incidencias..."
              :mobile-breakpoint="100"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, -1] }"
            >
              <template v-slot:item.fecha="{ item }">
                {{ formatearFecha(item.fecha) }}
              </template>
              <template v-slot:item.fecha_creacion="{ item }">
                {{ formatearFechaHora(item.fecha_creacion) || '—' }}
              </template>
              <template v-slot:item.tipo="{ item }">
                {{ textoTipo(item.tipo) }}
              </template>
              <template v-slot:item.estatus="{ item }">
                <v-chip x-small :color="colorEstatus(item.estatus)" dark>{{ textoEstatus(item.estatus) }}</v-chip>
              </template>
              <template v-slot:item.responsable_nombre="{ item }">
                <span>{{ item.responsable_nombre || '—' }}</span>
              </template>
              <template v-slot:item.respuestas="{ item }">
                <v-btn
                  v-if="muestraLupa(item)"
                  color="primary"
                  x-small
                  tile
                  @click="abrirDetalle(item)"
                >
                  <v-icon small>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="muestraResponder(item)"
                  text
                  small
                  color="primary"
                  @click="abrirDetalle(item)"
                >{{ item.estatus === 'cerrada' ? 'Ver' : 'Responder' }}</v-btn>
              </template>
              <template v-slot:no-data>
                <div class="py-8 text-center grey--text">No hay incidencias con los filtros actuales</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogAlta" max-width="640px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon left color="orange darken-2">mdi-clipboard-plus-outline</v-icon>
          Registrar incidencia
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-autocomplete
            v-model="form.id_colaborador"
            :items="equipo"
            item-text="nombre_completo"
            item-value="id_usuario"
            label="Colaborador"
            filled
            dense
            hide-details
            class="mb-3"
            @change="onColaboradorChange"
          ></v-autocomplete>
          <v-text-field
            v-model="form.puesto"
            label="Puesto"
            filled
            dense
            hide-details
            readonly
            class="mb-3"
          ></v-text-field>
          <v-text-field
            :value="sucursalSeleccionada"
            label="Departamento / sucursal"
            filled
            dense
            hide-details
            readonly
            class="mb-3"
          ></v-text-field>
          <v-select
            v-model="form.tipo"
            :items="tipos"
            item-text="texto"
            item-value="id"
            label="Tipo de incidencia"
            filled
            dense
            hide-details
            class="mb-3"
          ></v-select>
          <v-text-field
            v-model="form.fecha"
            type="date"
            label="Fecha"
            filled
            dense
            hide-details
            class="mb-3"
          ></v-text-field>
          <v-textarea
            v-model="form.descripcion"
            label="Descripción"
            filled
            dense
            rows="3"
            hide-details
            class="mb-3"
          ></v-textarea>
          <v-file-input
            v-model="evidenciaFiles"
            label="Agregar evidencias *"
            filled
            dense
            hide-details
            multiple
            small-chips
            prepend-icon="mdi-paperclip"
            accept="image/bmp,image/gif,image/jpeg,image/png,image/webp,.bmp,.gif,.jpg,.jpeg,.png,.webp"
            show-size
            @change="onEvidenciasChange"
          ></v-file-input>
          <div class="caption grey--text mt-1">
            Obligatoria al menos una imagen. Puedes seleccionar varias a la vez o ir agregando más.
          </div>
          <v-row v-if="evidenciasAlta.length" class="mt-2">
            <v-col
              v-for="(prev, idx) in evidenciasAlta"
              :key="'ev-prev-' + idx + '-' + prev.name"
              cols="6"
              sm="4"
              md="3"
            >
              <v-card class="py-2 shadowCard">
                <v-img :src="prev.url" contain aspect-ratio="1" min-height="96"></v-img>
                <div class="caption text-truncate px-2 mt-1">{{ prev.name }}</div>
                <v-btn color="error" small top right absolute fab @click="quitarEvidencia(idx)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogAlta = false">Cancelar</v-btn>
          <v-btn color="primary" small depressed :loading="guardando" @click="guardarAlta">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDetalle"
      persistent
      max-width="600px"
      @keydown.esc="dialogDetalle = false"
    >
      <v-card v-if="detalle">
        <v-card-title>
          <v-icon left color="blue-grey">mdi-file-document-outline</v-icon>
          <span class="headline">Folio: {{ detalle.id }}</span>
          <v-chip
            v-if="detalle.estatus"
            class="ml-3"
            x-small
            :color="colorEstatus(detalle.estatus)"
            dark
          >{{ textoEstatus(detalle.estatus) }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogDetalle = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="detalle.estatus === 'cerrada'"
            dense
            text
            type="success"
            class="mb-3"
          >
            Incidencia cerrada.
          </v-alert>
          <div class="d-flex justify-space-between align-start mb-3">
            <strong>Motivo de la incidencia</strong>
            <span class="text-right ml-4">
              <span v-if="detalle.jefe_nombre">Subió: {{ detalle.jefe_nombre }} · </span>
              {{ formatearFechaHora(detalle.fecha_creacion) || formatearFecha(detalle.fecha) }}
            </span>
          </div>
          <div class="incidencia-msg incidencia-msg-izq mb-4">
            {{ detalle.descripcion || 'Sin descripción' }}
            <span class="incidencia-msg-fecha">{{ formatearFechaHora(detalle.fecha_creacion) || formatearFecha(detalle.fecha) }}</span>
          </div>
          <v-row v-if="evidenciasDetalle.length" class="mb-4">
            <v-col
              v-for="(ev, idx) in evidenciasDetalle"
              :key="'ev-det-' + idx + '-' + ev"
              cols="6"
              sm="4"
              md="3"
            >
              <v-card class="py-2 shadowCard evidencia-card" @click="abrirImagenEvidencia(idx)">
                <v-img :src="urlEvidencia(ev)" contain aspect-ratio="1"></v-img>
              </v-card>
            </v-col>
          </v-row>
          <div v-for="s in seguimiento" :key="'seg-' + s.id">
            <div v-if="esComentarioJefe(s)" class="incidencia-msg incidencia-msg-izq mb-4">
              {{ textoSeguimiento(s) }}
              <span class="incidencia-msg-fecha">{{ formatearFechaHora(s.fecha_creacion) }}</span>
            </div>
            <div v-else>
              <div class="text-right mb-1">Respondió: <strong>{{ s.usuario_nombre || '—' }}</strong></div>
              <div class="incidencia-msg incidencia-msg-der mb-4 ml-auto">
                {{ textoSeguimiento(s) }}
                <span class="incidencia-msg-fecha">{{ formatearFechaHora(s.fecha_creacion) }}</span>
              </div>
            </div>
          </div>
          <v-textarea
            v-if="puedeEscribirRespuesta"
            v-model="nuevoComentario"
            label="Respuesta"
            outlined
            dense
            rows="3"
            hide-details
            class="mt-2"
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="puedeEliminar" color="error" dark small @click="dialogEliminar = true">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="puedeEscribirRespuesta" color="success darken-1" small :loading="guardando" @click="enviarComentario">Responder</v-btn>
          <v-btn v-if="puedeCerrar" color="success" dark small @click="confirmarCierre">Cerrar incidencia</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCatalogoTipos" max-width="640px" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon left color="blue-grey">mdi-format-list-bulleted</v-icon>
          Catálogo de tipos de incidencia
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogCatalogoTipos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div v-if="puedeEditarTipos" class="d-flex align-center mb-4" style="gap: 8px;">
            <v-text-field
              v-model="nuevoTipoTexto"
              label="Nuevo tipo"
              filled
              dense
              hide-details
              class="flex-grow-1"
              @keyup.enter="guardarNuevoTipo"
            ></v-text-field>
            <v-btn color="primary" small depressed :loading="guardandoTipo" @click="guardarNuevoTipo">Agregar</v-btn>
          </div>
          <v-data-table
            :headers="headersTipos"
            :items="tipos"
            dense
            hide-default-footer
            disable-pagination
            item-key="id"
            class="elevation-0"
          >
            <template v-slot:item.texto="{ item }">
              <v-text-field
                v-if="puedeEditarTipos"
                v-model="item.texto"
                dense
                hide-details
                filled
                @blur="actualizarTipo(item)"
              ></v-text-field>
              <span v-else>{{ item.texto }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn v-if="puedeEditarTipos" icon small color="error" @click="eliminarTipo(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <div class="py-4 text-center grey--text">No hay tipos registrados</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRechazo" max-width="480px">
      <v-card>
        <v-card-title class="text-subtitle-1">Rechazar incidencia</v-card-title>
        <v-card-text>
          <v-textarea v-model="motivoRechazo" label="Motivo" filled dense rows="3" hide-details></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogRechazo = false">Cancelar</v-btn>
          <v-btn color="error" small depressed :loading="guardando" @click="confirmarRechazo">Rechazar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEliminar" max-width="300px">
      <v-card>
        <v-card-title>
          <span>Confirmación</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="dialogEliminar = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>¿Desea eliminar esta incidencia? Esta acción no se puede revertir.</v-card-text>
        <v-card-actions>
          <v-btn color="error" small rounded @click="dialogEliminar = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" small rounded :loading="guardando" @click="confirmarEliminar">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Imagen
      @close="dialogImagenEvidencia = false"
      :isOpen="dialogImagenEvidencia"
      :imagen="imagenEvidenciaNombre"
      :imagenes="imagenesEvidencia"
      :indiceInicial="indiceImagenEvidencia"
      :baseUrl="baseUrlEvidencia"
    />

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar && !dialogAlta && !dialogDetalle" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';
import validarErrores from '@/mixins/validarErrores';
import funcionesExcel from '@/mixins/funcionesExcel';
import axios from 'axios';
import Imagen from '@/views/operaciones/rh/ImagenIncidencia.vue';

var moment = require('moment');
moment.locale('es');

export default {
  name: 'IncidenciasColaboradores',
  components: { Alerta, carga, Imagen },
  mixins: [validarErrores, funcionesExcel],
  data: function () {
    return {
      cargar: false,
      guardando: false,
      esRh: false,
      esJefeOperaciones: false,
      puedeEditarTipos: false,
      lista: [],
      equipo: [],
      tipos: [
        { id: 'ausencia', texto: 'Ausencia' },
        { id: 'retardo', texto: 'Retardo' },
        { id: 'conducta', texto: 'Conducta inadecuada' },
        { id: 'politicas', texto: 'Incumplimiento de políticas' },
        { id: 'conflicto', texto: 'Conflicto' },
        { id: 'otro', texto: 'Otro' },
      ],
      search: '',
      filtroEstatus: null,
      filtroTipo: null,
      fechaFiltroDesde: '',
      fechaFiltroHasta: '',
      dialogAlta: false,
      dialogDetalle: false,
      dialogCierre: false,
      dialogRechazo: false,
      dialogEliminar: false,
      detalle: null,
      seguimiento: [],
      nuevoComentario: '',
      motivoRechazo: '',
      fechaCierre: '',
      dialogCatalogoTipos: false,
      nuevoTipoTexto: '',
      guardandoTipo: false,
      headersTipos: [
        { text: 'Tipo', value: 'texto' },
        { text: '', value: 'actions', sortable: false, width: '56px' },
      ],
      form: {
        id_colaborador: null,
        tipo: null,
        fecha: '',
        descripcion: '',
        puesto: '',
      },
      evidenciaFiles: [],
      evidenciasAlta: [],
      dialogImagenEvidencia: false,
      imagenEvidenciaNombre: '',
      imagenesEvidencia: [],
      indiceImagenEvidencia: 0,
      headers: [
        { text: 'Folio', value: 'id', width: '80px' },
        { text: 'Colaborador', value: 'colaborador' },
        { text: 'Puesto', value: 'puesto_colaborador' },
        { text: 'Sucursal', value: 'plantel' },
        { text: 'Tipo', value: 'tipo' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Fecha de carga', value: 'fecha_creacion' },
        { text: 'Jefe', value: 'jefe_nombre' },
        { text: 'Responsable', value: 'responsable_nombre' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Respuestas', value: 'respuestas', sortable: false, width: '110px' },
        { text: 'Responder', value: 'actions', sortable: false, width: '110px' },
      ],
      opcionesEstatus: [
        { id: 'abierta', texto: 'Abierta' },
        { id: 'en_seguimiento', texto: 'En seguimiento' },
        { id: 'rechazada', texto: 'Rechazada' },
        { id: 'cerrada', texto: 'Cerrada' },
      ],
    };
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    baseUrlEvidencia: function () {
      return (axios.defaults.baseURL || '') + 'evidencia-incidencias-colaboradores/';
    },
    listaFiltrada: function () {
      var lista = this.lista;
      if (this.filtroEstatus) {
        lista = lista.filter(function (el) {
          return el.estatus === this.filtroEstatus;
        }, this);
      }
      if (this.filtroTipo) {
        lista = lista.filter(function (el) {
          return el.tipo === this.filtroTipo;
        }, this);
      }
      if (this.fechaFiltroDesde) {
        lista = lista.filter(function (el) {
          return this.formatearFecha(el.fecha) >= this.fechaFiltroDesde;
        }, this);
      }
      if (this.fechaFiltroHasta) {
        lista = lista.filter(function (el) {
          return this.formatearFecha(el.fecha) <= this.fechaFiltroHasta;
        }, this);
      }
      return lista;
    },
    headersTabla: function () {
      var base = this.headers.filter(function (h) {
        return h.value !== 'respuestas' && h.value !== 'actions';
      });
      if (this.esRh) {
        base.push({ text: 'Responder', value: 'actions', sortable: false, width: '110px' });
      } else {
        base.push({ text: 'Respuestas', value: 'respuestas', sortable: false, width: '110px' });
      }
      return base;
    },
    chipsEstatus: function () {
      var iconos = {
        abierta: 'mdi-alert-circle-outline',
        en_seguimiento: 'mdi-message-reply-text',
        rechazada: 'mdi-close-circle-outline',
        cerrada: 'mdi-check-circle-outline',
      };
      return [{ id: null, texto: 'Todos', color: 'blue-grey', icon: 'mdi-filter-variant' }].concat(
        this.opcionesEstatus.map(function (e) {
          return {
            id: e.id,
            texto: e.texto,
            color: this.colorEstatus(e.id),
            icon: iconos[e.id] || 'mdi-circle-outline',
          };
        }, this)
      );
    },
    incidenciaMasAntigua: function () {
      var abiertas = this.lista.filter(function (el) {
        return el.estatus !== 'cerrada';
      });
      if (!abiertas.length) return null;
      abiertas.sort(function (a, b) {
        return String(a.fecha || '').localeCompare(String(b.fecha || ''));
      });
      return abiertas[0];
    },
    sucursalSeleccionada: function () {
      var c = this.colaboradorSeleccionado;
      if (!c) return '';
      var depto = c.departamento || '';
      var plantel = c.plantel || '';
      if (depto && plantel) return depto + ' / ' + plantel;
      return depto || plantel;
    },
    colaboradorSeleccionado: function () {
      var id = this.form.id_colaborador;
      return this.equipo.find(function (el) {
        return Number(el.id_usuario) === Number(id);
      }) || null;
    },
    puestoSeleccionado: function () {
      var c = this.colaboradorSeleccionado;
      return c && c.puesto ? c.puesto : '';
    },
    miIderp: function () {
      return Number((this.getdatosUsuarioERPERP || {}).iderp);
    },
    puedeComentar: function () {
      if (!this.detalle) return false;
      return this.detalle.estatus !== 'cerrada';
    },
    puedeEscribirRespuesta: function () {
      if (!this.detalle || this.detalle.estatus === 'cerrada') return false;
      var soyCreador = Number(this.detalle.id_jefe) === this.miIderp;
      var ultimo = this.seguimiento && this.seguimiento.length
        ? this.seguimiento[this.seguimiento.length - 1]
        : null;
      var ultimoEsDelJefe = !ultimo || Number(ultimo.id_usuario) === Number(this.detalle.id_jefe);
      if (soyCreador) {
        return !ultimoEsDelJefe;
      }
      if (this.esRh) {
        return ultimoEsDelJefe;
      }
      return false;
    },
    puedeEliminar: function () {
      if (!this.detalle || this.detalle.estatus === 'cerrada') return false;
      return Number(this.detalle.id_jefe) === this.miIderp;
    },
    puedeCerrar: function () {
      if (!this.detalle || this.detalle.estatus === 'cerrada') return false;
      return Number(this.detalle.id_jefe) === this.miIderp;
    },
    puedeRechazar: function () {
      if (!this.detalle || !this.puedeComentar) return false;
      return this.esRh || Number(this.detalle.id_jefe) === this.miIderp;
    },
    evidenciasDetalle: function () {
      if (!this.detalle) return [];
      var lista = this.detalle.evidencias;
      if (lista && lista.length) return lista;
      if (this.detalle.evidencia) return [this.detalle.evidencia];
      return [];
    },
  },
  created: function () {
    this.cargarInicial();
  },
  methods: {
    limpiarFiltros: function () {
      this.search = '';
      this.filtroEstatus = null;
      this.filtroTipo = null;
      this.fechaFiltroDesde = '';
      this.fechaFiltroHasta = '';
    },
    conteoEstatus: function (id) {
      if (!id) return this.lista.length;
      return this.lista.filter(function (el) {
        return el.estatus === id;
      }).length;
    },
    claseFila: function (item) {
      if (!item) return '';
      if (item.estatus === 'abierta') return 'incidencia-fila-abierta';
      if (item.estatus === 'en_seguimiento') return 'incidencia-fila-seguimiento';
      if (item.estatus === 'rechazada') return 'incidencia-fila-rechazada';
      return '';
    },
    hoyIso: function () {
      var d = new Date();
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
    },
    textoTipo: function (id) {
      var t = this.tipos.find(function (el) {
        return el.id === id;
      });
      return t ? t.texto : id;
    },
    textoEstatus: function (e) {
      var t = this.opcionesEstatus.find(function (el) {
        return el.id === e;
      });
      return t ? t.texto : e;
    },
    colorEstatus: function (e) {
      if (e === 'abierta') return 'orange';
      if (e === 'en_seguimiento') return 'blue';
      if (e === 'rechazada') return 'red';
      if (e === 'cerrada') return 'green';
      return 'grey';
    },
    esComentarioJefe: function (s) {
      if (!this.detalle || !s) return true;
      return Number(s.id_usuario) === Number(this.detalle.id_jefe);
    },
    muestraLupa: function (item) {
      if (this.esRh || !item) return false;
      if (this.esJefeOperaciones || this.miIderp === 568) return true;
      return Number(item.id_jefe) === this.miIderp;
    },
    muestraResponder: function (item) {
      if (!this.esRh || !item) return false;
      return true;
    },
    textoSeguimiento: function (s) {
      if (!s) return '';
      var t = s.comentario;
      if (t && typeof t === 'object') {
        if (t.data && t.data.length) {
          var chars = [];
          var i;
          for (i = 0; i < t.data.length; i++) chars.push(String.fromCharCode(t.data[i]));
          t = chars.join('');
        } else {
          t = '';
        }
      }
      if (t == null || t === '') return '';
      return String(t);
    },
    formatearFecha: function (val) {
      if (!val) return '—';
      return String(val).slice(0, 10);
    },
    formatearFechaHora: function (val) {
      if (!val) return '';
      var m = moment(val);
      if (!m.isValid()) return String(val);
      return m.format('MMMM Do YYYY, h:mm:ss a');
    },
    msgError: function (error, def) {
      if (error && error.body && error.body.message) return error.body.message;
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return def;
    },
    aplicarTipos: function (lista) {
      if (lista && lista.length) this.tipos = lista;
    },
    abrirCatalogoTipos: function () {
      if (!this.puedeEditarTipos) return;
      this.nuevoTipoTexto = '';
      this.dialogCatalogoTipos = true;
    },
    guardarNuevoTipo: function () {
      var self = this;
      if (!this.puedeEditarTipos) return;
      var texto = (this.nuevoTipoTexto || '').trim();
      if (!texto) return this.validarError('Escribe el nombre del tipo');
      this.guardandoTipo = true;
      this.$http
        .post('incidencias.colaboradores.tipos.add', { texto: texto })
        .then(function (r) {
          self.aplicarTipos(r.data && r.data.tipos);
          self.nuevoTipoTexto = '';
          self.validarSuccess('Tipo agregado');
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo agregar el tipo'));
        })
        .finally(function () {
          self.guardandoTipo = false;
        });
    },
    actualizarTipo: function (item) {
      var self = this;
      if (!this.puedeEditarTipos || !item || !item.id) return;
      var texto = (item.texto || '').trim();
      if (!texto) return;
      this.$http
        .put('incidencias.colaboradores.tipos.update/' + encodeURIComponent(item.id), { texto: texto })
        .then(function (r) {
          self.aplicarTipos(r.data && r.data.tipos);
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo actualizar el tipo'));
        });
    },
    eliminarTipo: function (item) {
      var self = this;
      if (!this.puedeEditarTipos || !item || !item.id) return;
      this.$http
        .post('incidencias.colaboradores.tipos.eliminar/' + encodeURIComponent(item.id))
        .then(function (r) {
          self.aplicarTipos(r.data && r.data.tipos);
          self.validarSuccess('Tipo eliminado');
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo eliminar el tipo'));
        });
    },
    cargarInicial: function () {
      var self = this;
      this.cargar = true;
      this.$http
        .get('incidencias.colaboradores.meta')
        .then(function (r) {
          self.esRh = !!(r.data && r.data.es_rh);
          self.esJefeOperaciones = !!(r.data && r.data.es_jefe_operaciones);
          self.puedeEditarTipos = !!(r.data && r.data.puede_editar_tipos);
          if (r.data && r.data.tipos && r.data.tipos.length) self.tipos = r.data.tipos;
        })
        .catch(function () {
          /* tipos locales */
        });
      this.$http
        .get('incidencias.colaboradores.equipo')
        .then(function (r) {
          self.equipo = r.data || [];
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo cargar el equipo'));
        });
      this.$http
        .get('incidencias.colaboradores')
        .then(function (r) {
          self.lista = r.data || [];
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo cargar el panel'));
        })
        .finally(function () {
          self.cargar = false;
        });
    },
    cargarLista: function () {
      var self = this;
      this.cargar = true;
      this.$http
        .get('incidencias.colaboradores')
        .then(function (r) {
          self.lista = r.data || [];
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudieron cargar las incidencias'));
        })
        .finally(function () {
          self.cargar = false;
        });
    },
    onColaboradorChange: function () {
      var c = this.colaboradorSeleccionado;
      this.form.puesto = c && (c.puesto || c.descripcion) ? (c.puesto || c.descripcion) : '';
    },
    abrirAlta: function () {
      this.form = {
        id_colaborador: null,
        tipo: null,
        fecha: this.hoyIso(),
        descripcion: '',
        puesto: '',
      };
      this.limpiarEvidenciasAlta();
      this.dialogAlta = true;
    },
    limpiarEvidenciasAlta: function () {
      (this.evidenciasAlta || []).forEach(function (item) {
        if (item && item.url) {
          try { URL.revokeObjectURL(item.url); } catch (e) { /* ignore */ }
        }
      });
      this.evidenciasAlta = [];
      this.evidenciaFiles = [];
    },
    normalizarArchivosEvidencia: function (files) {
      if (!files) return [];
      if (Array.isArray(files)) return files.filter(Boolean);
      if (typeof FileList !== 'undefined' && files instanceof FileList) {
        return Array.prototype.slice.call(files);
      }
      if (files && typeof files === 'object' && typeof files.length === 'number') {
        return Array.prototype.slice.call(files).filter(Boolean);
      }
      return [files];
    },
    esImagenEvidencia: function (f) {
      if (!f) return false;
      if (f.type && String(f.type).indexOf('image/') === 0) return true;
      var nombre = (f.name || '').toLowerCase();
      return /\.(bmp|gif|jpg|jpeg|png|webp)$/.test(nombre);
    },
    quitarEvidencia: function (idx) {
      var i = Number(idx);
      if (isNaN(i) || i < 0 || i >= this.evidenciasAlta.length) return;
      var item = this.evidenciasAlta[i];
      if (item && item.url) {
        try { URL.revokeObjectURL(item.url); } catch (e) { /* ignore */ }
      }
      this.evidenciasAlta.splice(i, 1);
    },
    onEvidenciasChange: function (files) {
      var self = this;
      var lista = this.normalizarArchivosEvidencia(files);
      if (!lista.length) {
        lista = this.normalizarArchivosEvidencia(this.evidenciaFiles);
      }
      if (!lista.length) return;

      var agregados = 0;
      var invalidos = 0;
      var i;
      for (i = 0; i < lista.length; i++) {
        var f = lista[i];
        if (!this.esImagenEvidencia(f)) {
          invalidos += 1;
          continue;
        }
        this.evidenciasAlta.push({
          file: f,
          name: f.name || ('evidencia-' + (this.evidenciasAlta.length + 1)),
          url: URL.createObjectURL(f),
        });
        agregados += 1;
      }

      if (invalidos && !agregados) {
        this.validarError('La evidencia debe ser una imagen');
      } else if (invalidos) {
        this.validarError('Se omitieron archivos que no son imagen');
      }

      // Limpia el input para poder seguir agregando sin reemplazar la galería
      this.$nextTick(function () {
        self.evidenciaFiles = [];
      });
    },
    urlEvidencia: function (nombre) {
      if (!nombre) return '';
      return this.baseUrlEvidencia + nombre;
    },
    abrirImagenEvidencia: function (idx) {
      var lista = this.evidenciasDetalle;
      if (!lista.length) return;
      var i = Number(idx);
      if (isNaN(i) || i < 0 || i >= lista.length) i = 0;
      this.indiceImagenEvidencia = i;
      this.imagenEvidenciaNombre = lista[i];
      this.imagenesEvidencia = lista.map(function (foto) {
        return { foto: foto };
      });
      this.dialogImagenEvidencia = true;
    },
    guardarAlta: function () {
      var self = this;
      if (!this.form.id_colaborador || !this.form.tipo || !this.form.fecha) {
        return this.validarError('Completa colaborador, tipo y fecha');
      }
      var archivos = (this.evidenciasAlta || []).map(function (item) {
        return item.file;
      }).filter(Boolean);
      if (!archivos.length) {
        return this.validarError('La evidencia es obligatoria (al menos una imagen)');
      }
      var fd = new FormData();
      fd.append('id_colaborador', this.form.id_colaborador);
      fd.append('tipo', this.form.tipo);
      fd.append('fecha', this.form.fecha);
      fd.append('descripcion', this.form.descripcion || '');
      if (this.form.puesto) fd.append('puesto', this.form.puesto);
      archivos.forEach(function (f) {
        fd.append('evidencia', f);
      });
      this.guardando = true;
      this.$http
        .post('incidencias.colaboradores.add', fd)
        .then(function (r) {
          self.validarSuccess((r.data && r.data.message) || 'Incidencia registrada');
          self.dialogAlta = false;
          self.limpiarEvidenciasAlta();
          self.cargarLista();
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo registrar'));
        })
        .finally(function () {
          self.guardando = false;
        });
    },
    abrirDetalle: function (item) {
      var self = this;
      this.cargar = true;
      this.$http
        .get('incidencias.colaboradores/' + item.id)
        .then(function (r) {
          self.detalle = r.data.incidencia;
          self.seguimiento = r.data.seguimiento || [];
          if (r.data.es_rh != null) self.esRh = !!r.data.es_rh;
          if (r.data.es_jefe_operaciones != null) self.esJefeOperaciones = !!r.data.es_jefe_operaciones;
          self.nuevoComentario = '';
          self.dialogDetalle = true;
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo abrir la incidencia'));
        })
        .finally(function () {
          self.cargar = false;
        });
    },
    recargarDetalle: function () {
      if (!this.detalle) return Promise.resolve();
      var self = this;
      return this.$http.get('incidencias.colaboradores/' + this.detalle.id).then(function (r) {
        self.detalle = r.data.incidencia;
        self.seguimiento = r.data.seguimiento || [];
      });
    },
    enviarComentario: function () {
      var self = this;
      if (!this.nuevoComentario || !this.nuevoComentario.trim()) {
        return this.validarError('Escribe una respuesta');
      }
      this.guardando = true;
      this.$http
        .post('incidencias.colaboradores.comentar/' + this.detalle.id, {
          comentario: this.nuevoComentario.trim(),
        })
        .then(function () {
          self.nuevoComentario = '';
          return self.recargarDetalle();
        })
        .then(function () {
          self.cargarLista();
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo comentar'));
        })
        .finally(function () {
          self.guardando = false;
        });
    },
    abrirCierre: function () {
      this.confirmarCierre();
    },
    confirmarCierre: function () {
      var self = this;
      if (!this.detalle) return;
      this.guardando = true;
      this.$http
        .post('incidencias.colaboradores.cerrar/' + this.detalle.id, {})
        .then(function (r) {
          self.validarSuccess((r.data && r.data.message) || 'Incidencia cerrada');
          return self.recargarDetalle();
        })
        .then(function () {
          self.cargarLista();
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo cerrar'));
        })
        .finally(function () {
          self.guardando = false;
        });
    },
    confirmarRechazo: function () {
      var self = this;
      if (!this.motivoRechazo || !this.motivoRechazo.trim()) {
        return this.validarError('Indica el motivo del rechazo');
      }
      this.guardando = true;
      this.$http
        .post('incidencias.colaboradores.rechazar/' + this.detalle.id, {
          comentario: this.motivoRechazo.trim(),
        })
        .then(function (r) {
          self.validarSuccess((r.data && r.data.message) || 'Incidencia rechazada');
          self.dialogRechazo = false;
          self.motivoRechazo = '';
          return self.recargarDetalle();
        })
        .then(function () {
          self.cargarLista();
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo rechazar'));
        })
        .finally(function () {
          self.guardando = false;
        });
    },
    confirmarEliminar: function () {
      var self = this;
      if (!this.detalle) return;
      this.guardando = true;
      this.$http
        .post('incidencias.colaboradores.eliminar/' + this.detalle.id)
        .then(function (r) {
          self.validarSuccess((r.data && r.data.message) || 'Incidencia eliminada');
          self.dialogEliminar = false;
          self.dialogDetalle = false;
          self.cargarLista();
        })
        .catch(function (error) {
          self.validarError(self.msgError(error, 'No se pudo eliminar'));
        })
        .finally(function () {
          self.guardando = false;
        });
    },
    exportar: function () {
      var filas = this.listaFiltrada.map(function (i) {
        return {
          Folio: i.id,
          Colaborador: i.colaborador,
          Departamento: i.departamento,
          Sucursal: i.plantel,
          Tipo: this.textoTipo(i.tipo),
          Fecha: this.formatearFecha(i.fecha),
          'Fecha de carga': this.formatearFechaHora(i.fecha_creacion),
          Jefe: i.jefe_nombre,
          Responsable: i.responsable_nombre,
          Puesto: i.puesto_colaborador,
          Estatus: this.textoEstatus(i.estatus),
          Descripcion: i.descripcion,
        };
      }, this);
      this.exportExcel(filas, 'INCIDENCIAS_COLABORADORES');
    },
  },
};
</script>

<style>
.incidencia-msg {
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: break-word;
  display: block;
  width: 80%;
  padding: 8px 12px;
  box-sizing: border-box;
}
.incidencia-msg-izq {
  background-color: rgb(238, 235, 235);
  border-radius: 0px 10px 10px 10px;
}
.incidencia-msg-der {
  background-color: rgb(193, 231, 243);
  border-radius: 10px 0px 10px 10px;
}
.incidencia-msg-fecha {
  display: block;
  font-size: small;
  text-align: right;
  margin-top: 6px;
}
.evidencia-card {
  cursor: pointer;
}
.incidencia-metricas {
  position: relative;
  gap: 8px 16px;
  overflow: hidden;
  border: 1px solid #b692ec;
  background: linear-gradient(90deg, #eadcfb 0%, #fbf8ff 45%, #e3f7e7 100%) !important;
  box-shadow: 0 4px 14px rgba(80, 45, 130, 0.18) !important;
}
.incidencia-metricas::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 7px;
  background: linear-gradient(180deg, #512da8 0%, #7e57c2 100%);
}
.incidencia-metrica-item {
  min-width: 260px;
}
.incidencia-metrica-icon {
  align-items: center;
  background: #d9c7f4;
  border: 1px solid #b692ec;
  border-radius: 999px;
  display: flex;
  height: 38px;
  justify-content: center;
  width: 38px;
}
.incidencia-metrica-valor {
  font-size: 1rem;
  line-height: 1.25;
}
.incidencia-metrica-chip {
  box-shadow: 0 2px 8px rgba(80, 45, 130, 0.12);
}
.incidencia-buscar.v-text-field--outlined.v-input--dense .v-input__slot {
  min-height: 36px !important;
}
.incidencia-fila-abierta {
  background-color: #fff8e1;
}
.incidencia-fila-seguimiento {
  background-color: #e3f2fd;
}
.incidencia-fila-rechazada {
  background-color: #ffebee;
}
</style>
